import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './PolicyScheduleItemsComponent.metadata.json5';
import messages from './PolicyScheduleItemsComponent.messages';

const getCellCoverageName = (rowData) => {
    let coverageName = '';
    if (rowData.terms[3] !== undefined) {
     coverageName = rowData.terms[3].amount;
    } else {
        coverageName = rowData.terms[0].amount;
    }
    return (
        <span>
            {coverageName}
        </span>
    );
};

const getCellCoverageLimit = (rowData) => {
    return (
        <span>
            {rowData.limit}
        </span>
    );
};

const getCellCoverageDeductible = (rowData) => {
    return (
        <span>
            {rowData.deductible}
        </span>
    );
};


function PolicyScheduleItemsComponent(props) {
    const { value: currentPeriodDetails } = props;
  //  console.log('scheduleItem', currentPeriodDetails);
      let coverables = currentPeriodDetails.coverables;
    if (_.isEmpty(coverables) || coverables === undefined) {
        return null;
    }

    const policyScheduleItemsCoverables = useCallback(() => {
        let coverages = [];
        coverables.forEach((coverable) => {
           if(coverable.name === 'Personal Property' || coverable.name === 'Jewellery & Watches' || coverable.name === 'Boat, Motor, Trailer or other means of Transportation'){
                //coverages = coverable.coverages;
                coverages= coverages.concat(coverable.coverages);
            }
        });
  //      console.log("combined: " + coverages);
        return coverages;
    }, [coverables]);


    const generateScheduleItemsTableOverrides = useCallback(() => {
        return {
            coverageColumn: { onCell: getCellCoverageName },
            limitColumn: { onCell: getCellCoverageLimit },
            deductibleColumn: { onCell: getCellCoverageDeductible }
        };
    }, [policyScheduleItemsCoverables]);

    const overrides = {
       /*  PolicyScheduleItems: {
            data: coverables
        }, */
        policyScheduleItemsTable: {
            data: policyScheduleItemsCoverables()
        },
        ...generateScheduleItemsTableOverrides()
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={coverables}
            overrideProps={overrides}
        />
    );
}


PolicyScheduleItemsComponent.propTypes = {
    value: PropTypes.shape({})
};

PolicyScheduleItemsComponent.defaultProps = {
    value: []
};

export default PolicyScheduleItemsComponent;
